export default __webpack_public_path__ + "static/media/logo-bdswiss-white.d49ac303.svg";